export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-ease/src/linear.js
// module id = ./node_modules/d3-ease/src/linear.js
// module chunks = 1